// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --last-pill-width: 72px;
}

.popup_hZESj {
  margin-top: var(--size-padSmall);
  border-radius: 8px !important;
}

.popupTrigger_Yg1TA {
  width: 100%;
  display: flex;
  gap: var(--size-padMedium);
  cursor: pointer;
}

.shrinkableFirstPill_X4L7M {
  max-width: calc(100% - var(--last-pill-width) - var(--size-pad12));
}

.firstPill_WQmyp {
  max-width: 100%;
}

.lastPill_JeVMI {
  min-width: var(--last-pill-width);
}

.selectableText_o9X9e {
  -moz-user-select: text;
  -khtml-user-select: text;
  -webkit-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.popupHeader_LJZF4 {
  height: 40px;
  width: 430px;
  font-size: 16px;
  font-weight: bold;
  color: var(--color-base600);
  padding-left: var(--size-padLarge);
  padding-right: var(--size-padLarge);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.popupCloseButton_sWeVz {
  top: var(--size-pad12);
  right: var(--size-padLarge);
  position: absolute;
}

.popupItemsContainer_S_bmB {
  max-height: 220px;
  width: 100%;
  overflow-y: auto;
}

.popupItemsContainer_S_bmB :nth-child(odd) {
  background-color: var(--color-base025);
}

.popupItem_h6PRu {
  height: 36px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 var(--size-padLarge);
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/attributes/renderers/vehicle/AlertPopup.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;AACjB","sourcesContent":[":root {\n  --last-pill-width: 72px;\n}\n\n.popup {\n  margin-top: var(--size-padSmall);\n  border-radius: 8px !important;\n}\n\n.popupTrigger {\n  width: 100%;\n  display: flex;\n  gap: var(--size-padMedium);\n  cursor: pointer;\n}\n\n.shrinkableFirstPill {\n  max-width: calc(100% - var(--last-pill-width) - var(--size-pad12));\n}\n\n.firstPill {\n  max-width: 100%;\n}\n\n.lastPill {\n  min-width: var(--last-pill-width);\n}\n\n.selectableText {\n  -moz-user-select: text;\n  -khtml-user-select: text;\n  -webkit-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n\n.popupHeader {\n  height: 40px;\n  width: 430px;\n  font-size: 16px;\n  font-weight: bold;\n  color: var(--color-base600);\n  padding-left: var(--size-padLarge);\n  padding-right: var(--size-padLarge);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.popupCloseButton {\n  top: var(--size-pad12);\n  right: var(--size-padLarge);\n  position: absolute;\n}\n\n.popupItemsContainer {\n  max-height: 220px;\n  width: 100%;\n  overflow-y: auto;\n}\n\n.popupItemsContainer :nth-child(odd) {\n  background-color: var(--color-base025);\n}\n\n.popupItem {\n  height: 36px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 0 var(--size-padLarge);\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `popup_hZESj`,
	"popupTrigger": `popupTrigger_Yg1TA`,
	"shrinkableFirstPill": `shrinkableFirstPill_X4L7M`,
	"firstPill": `firstPill_WQmyp`,
	"lastPill": `lastPill_JeVMI`,
	"selectableText": `selectableText_o9X9e`,
	"popupHeader": `popupHeader_LJZF4`,
	"popupCloseButton": `popupCloseButton_sWeVz`,
	"popupItemsContainer": `popupItemsContainer_S_bmB`,
	"popupItem": `popupItem_h6PRu`
};
export default ___CSS_LOADER_EXPORT___;
